import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Popover from 'react-awesome-popover';
import config from '../../../config/config.js';
import axios from 'axios';
import Select2 from 'react-select2-wrapper';

class AddLocation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            availableLocations: [],
            locationToAdd: null
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.loadAvailableLocations = this.loadAvailableLocations.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleOpen() {
        this.setState({
            open: true,
            availableLocations: [],
            locationToAdd: null
        });
        this.loadAvailableLocations();
    }

    handleClose() {
        this.setState({
            availableLocations: [],
            locationToAdd: null,
            open: false
        });
        this.props.handleClose();
    }

    loadAvailableLocations() {
        let that = this;
        axios(config.server.endpoint + 'backend/route/availableLocations', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    availableLocations: response.data
                });
            }
        });
    }

    handleSave() {
        let that = this;
        axios(config.server.endpoint + 'backend/route/location/' + that.props.id, {
            method: 'post',
            data: {
                location: that.state.locationToAdd
            }
        }).then((response) => {
            if (response.status === 200) {
                if(response.data.success === true) {
                    that.handleClose();
                } else {
                    alert('an error occured');
                }
            }
        });
    }

    render() {
        const { t } = this.props;
        return (
            <Popover targetClass="m-l-xs" onOpen={this.handleOpen} onClose={this.handleClose} open={this.state.open} contentClass="rap-popover-content">
                <a>
                    <i className="fa fa-plus"/>
                </a>
                <div className="p-md" style={{width: 400, textAlign: 'left'}}>
                    <div
                        className="form-group">
                        <label>{t('route.locationToAdd.label')}</label>
                        <Select2 data={this.state.availableLocations.map((el) => {
                            return {
                                text: el.name, id: el.id
                            }
                        })} value={this.state.locationToAdd} onChange={this.handleInputChange} name="locationToAdd"
                                 options={{placeholder: t('route.locationToAdd.placeholder')}}
                                 className="width-100p block"/>
                    </div>
                    <button className="btn btn-small btn-primary" onClick={this.handleSave}>
                        <i className="fa fa-save m-r-sm"/>
                        {t('default.save')}
                    </button>
                </div>
            </Popover>
        )
    }
}

export default translate()(AddLocation);